// extracted by mini-css-extract-plugin
export var blogPostExcerpt = "BlogPostExcerpt-module--blogPostExcerpt--46c53";
export var bottom = "BlogPostExcerpt-module--bottom--d5129";
export var excerpt = "BlogPostExcerpt-module--excerpt--705ef";
export var inner = "BlogPostExcerpt-module--inner--eb327";
export var left = "BlogPostExcerpt-module--left--9f343";
export var metadata = "BlogPostExcerpt-module--metadata--2abf7";
export var mobileMetadata = "BlogPostExcerpt-module--mobileMetadata--edaf6";
export var readMore = "BlogPostExcerpt-module--readMore--644aa";